export default __webpack_public_path__ + "flower_icon.dedb9271.svg";